import React from 'react';
import { Icons } from 'Assets';
import { useAppContext } from 'Contexts';
import { Anchor, BasketHeaderIcon } from 'Components';
import { ConnectionType } from 'Constants';

export const Header: React.FC = () => {
  const { connectionType, basketQuantity } = useAppContext();

  return (
    <div className="border-b-[1px] bg-white border-whitesmoke md:flex md:justify-center">
      <div className="grid grid-cols-3 w-full items-center justify-items-center px-4 py-2 md:grid-cols-2 md:max-w-[980px] md:px-0 md:mx-4">
        <Anchor className="col-start-2 md:col-start-[unset] md:justify-self-start" href="/">
          <img
            src={connectionType === ConnectionType.DPRO ? Icons.DartyProLogo : Icons.DartyComLogo}
            alt={connectionType === ConnectionType.DPRO ? 'darty pro' : 'darty com'}
            className="h-[34px] md:h-[40px]"
          />
        </Anchor>

        <BasketHeaderIcon className="justify-self-end" quantity={basketQuantity} />
      </div>
    </div>
  );
};
